import { differenceInDays, differenceInHours, startOfDay, isAfter, isSameDay } from 'date-fns';

export interface CountdownResult {
  label: string;
  expired: boolean;
  urgent: boolean; // ≤ 2 days
}

export function getOfferCountdown(dateStr: string): CountdownResult {
  const now = new Date();
  const target = startOfDay(new Date(dateStr));
  const today = startOfDay(now);

  if (isAfter(today, target)) {
    return { label: 'Expired', expired: true, urgent: false };
  }

  if (isSameDay(today, target)) {
    return { label: 'Ends today', expired: false, urgent: true };
  }

  const days = differenceInDays(target, today);

  if (days === 1) {
    return { label: 'Ends tomorrow', expired: false, urgent: true };
  }

  if (days <= 7) {
    return { label: `${days} days left`, expired: false, urgent: days <= 2 };
  }

  return { label: `${days} days left`, expired: false, urgent: false };
}
